import React from 'react';
import { MapPin, Phone, Mail, Factory } from 'lucide-react';

const About = () => {
  return (
    <div className="bg-white">
      {/* Hero */}
      <section className="bg-gray-900 text-white py-12 md:py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-3 sm:mb-4">À Propos de NEOPLIAGE</h1>
          <p className="text-base sm:text-xl">Notre histoire, nos valeurs, notre savoir-faire</p>
        </div>
      </section>

      {/* Main content */}
      <section className="container mx-auto px-4 py-10 md:py-16">
        <div className="max-w-4xl mx-auto">
          {/* Introduction */}
          <div className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Qui sommes-nous ?</h2>
            <p className="text-gray-700 text-lg mb-4">
              <strong>NEOPLIAGE</strong> est la marque spécialisée dans le pliage aluminium de <strong>NEOMAT</strong>, 
              entreprise française implantée à Ambérieu-en-Bugey dans l'Ain depuis sa création.
            </p>
            <p className="text-gray-700 text-lg mb-4">
              Nous sommes spécialisés dans la conception et la fabrication de pièces en aluminium pour le secteur du bâtiment. 
              Notre expertise nous permet de répondre aux besoins des professionnels comme des particuliers avec des solutions 
              sur-mesure et de qualité.
            </p>
          </div>

          {/* Notre expertise */}
          <div className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Notre Expertise</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
              <div className="bg-gray-50 p-6 rounded-lg">
                <Factory className="w-12 h-12 text-[#E42313] mb-4" />
                <h3 className="text-xl font-bold text-gray-900 mb-3">Fabrication française</h3>
                <p className="text-gray-700">
                  Toutes nos pièces sont fabriquées dans notre atelier à Ambérieu-en-Bugey avec des équipements 
                  de dernière génération.
                </p>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg">
                <svg className="w-12 h-12 text-[#E42313] mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Qualité garantie</h3>
                <p className="text-gray-700">
                  Nous utilisons uniquement de l'aluminium de haute qualité avec des finitions durables et résistantes.
                </p>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg">
                <svg className="w-12 h-12 text-[#E42313] mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Réactivité</h3>
                <p className="text-gray-700">
                  Délais de fabrication rapides et service client disponible pour répondre à toutes vos questions.
                </p>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg">
                <svg className="w-12 h-12 text-[#E42313] mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Sur-mesure</h3>
                <p className="text-gray-700">
                  Possibilité de fabrication sur-mesure pour répondre à vos projets spécifiques.
                </p>
              </div>
            </div>
          </div>

          {/* Nos produits */}
          <div className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Notre Gamme de Produits</h2>
            <ul className="space-y-3 text-gray-700 text-lg">
              <li className="flex items-start">
                <span className="text-[#E42313] mr-3 mt-1">✓</span>
                <span><strong>Couvertines en aluminium :</strong> protection optimale pour vos murs et acrotères</span>
              </li>
              <li className="flex items-start">
                <span className="text-[#E42313] mr-3 mt-1">✓</span>
                <span><strong>Habillages de bandeaux :</strong> finition parfaite pour vos toitures</span>
              </li>
              <li className="flex items-start">
                <span className="text-[#E42313] mr-3 mt-1">✓</span>
                <span><strong>Chapeaux de pilier :</strong> protection et esthétique pour vos piliers</span>
              </li>
              <li className="flex items-start">
                <span className="text-[#E42313] mr-3 mt-1">✓</span>
                <span><strong>Appuis de fenêtre :</strong> solutions durables et élégantes</span>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="bg-[#E42313] text-white rounded-lg p-6 sm:p-8">
            <h2 className="text-2xl sm:text-3xl font-bold mb-6">Nous Contacter</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
              <div className="flex items-start gap-3">
                <MapPin className="w-6 h-6 flex-shrink-0 mt-1" />
                <div>
                  <p className="font-semibold mb-1">Adresse</p>
                  <p>23 Avenue de la Libération</p>
                  <p>01500 Ambérieu-en-Bugey</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Phone className="w-6 h-6 flex-shrink-0 mt-1" />
                <div>
                  <p className="font-semibold mb-1">Téléphone</p>
                  <p>06.37.06.03.16</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Mail className="w-6 h-6 flex-shrink-0 mt-1" />
                <div>
                  <p className="font-semibold mb-1">Email</p>
                  <p>contact@neopliage.fr</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
